import request from '@/config/axios'

/** 玄学签到规则 VO（固定 7 行，仅可改 integral；第 7 天为连续签到封顶值） */
export interface CheckinRuleVo {
  id: number
  dayNo: number
  integral: number
}

/** 玄学签到记录 VO */
export interface CheckinRecordVo {
  id: number
  memberId: number
  memberNickname?: string
  checkinDate: string
  integral: number
  continuousDays: number
  createTime?: Date
}

/** 签到记录分页查询参数（昵称模糊/手机号精确/签到日期范围，后端经 member-api 解析） */
export interface CheckinRecordPageParams {
  pageNo?: number
  pageSize?: number
  memberId?: number
  nickname?: string
  mobile?: string
  checkinDate?: string[]
}

export const CheckinRuleApi = {
  // 查询签到规则列表（day_no 升序，末位即封顶档）
  getCheckinRuleList: () => {
    return request.get({ url: '/xuanxue/checkin-rule/list' })
  },
  // 新增签到档位（约束式：仅末尾追加，day_no 后端自动分配）
  createCheckinRule: (data: { integral: number }) => {
    return request.post({ url: '/xuanxue/checkin-rule/create', data })
  },
  // 更新签到规则（仅 integral）
  updateCheckinRule: (data: CheckinRuleVo) => {
    return request.put({ url: '/xuanxue/checkin-rule/update', data })
  },
  // 删除签到档位（约束式：仅允许删除最后一天档位，至少保留 1 档）
  deleteCheckinRule: (id: number) => {
    return request.delete({ url: '/xuanxue/checkin-rule/delete?id=' + id })
  }
}

export const CheckinRecordApi = {
  // 查询签到记录分页（memberId 可选筛选，含会员昵称）
  getCheckinRecordPage: (params: CheckinRecordPageParams) => {
    return request.get({ url: '/xuanxue/checkin-record/page', params })
  }
}
